// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ee63e779","732":"9dc29ee1","977":"0e8b276b"}[chunkId] + ".chunk.js";
};